// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"670":"f81f0ed806d91028","1017":"b040afa6ad2625fb","1391":"6d0a3394461a75d5","7380":"e392895eee7880a0"}[chunkId] + ".css";
};